module.exports = __webpack_public_path__ + "media/pexels.c761ba52.mp4";